export default "__VITE_ASSET__tU15dfFv__"